const etrActions = {
	ownerAndHolder: "ownerAndHolder",
	ownerOnly: "ownerOnly",
	holderAndEndorseOwner: "holderAndEndorseOwner",
	holderOnly: "holderOnly",
	acceptRejectSurrender: "acceptRejectSurrender",
	none: "none",
	surrender: "surrender",
	shred: "shred"
}

const etrActionable = {
	transferOwnerAndHolder: "transferOwnerAndHolder",
	transferOwner: "transferOwner",
	transferHolder: "transferHolder",
	rejectTransferOwner: "rejectTransferOwner",
	rejectTransferHolder: "rejectTransferHolder",
	rejectTransferOwnerHolder: "rejectTransferOwnerHolder",
	endorseOwner: "endorseOwner",
	acceptSurrender: "acceptSurrender",
	rejectSurrender: "rejectSurrender",
	surrender: "surrender",
	rejectTransfer: "rejection"
}

const MAKER_CHECKER_ETR_MODAL_CONTENT = {
	TRANSFER_OWNERSHIP: {
		header: "Transfer Ownership",
		body: "This action will change the legal ownership of the ETR. Please confirm the details of the new owner."
	},
	NOMINATE_OWNER: {
		header: "Transfer Ownership",
		body: "This action will initiate the process to transfer the ETR to the nominated party upon approval. Please verify the nominee's details carefully."
	},
	TRANSFER_HOLDER: {
		header: "Transfer Holdership",
		body: "This action will change who has control over the ETR. Ensure the new holder is informed and agrees to this change."
	},
	TRANSFER_OWNERSHIP_HOLDERSHIP: {
		header: "Transfer Ownership & Holdership",
		body: "This action will change the legal ownership & holdership of the ETR. Please confirm the details of the new owner & holder."
	},
	ENDORSE_OWNERSHIP: {
		header: "Endorse Transfer",
		body: "This action will finalise the change in beneficiary. Please ensure this aligns with the intended outcome of the nomination."
	},
	SURRENDER: {
		header: "Surrender Record",
		body: "This action will relinquish all rights associated with the ETR. Please confirm your decision."
	}
}

const MAKER_CHECKER_ETR_MODAL_CONTENT_V5 = {
	TRANSFER_OWNERSHIP: {
		header: "Transfer Ownership",
		body: "This action will initiate the process to transfer the ETR to the nominated party upon approval. Please verify the nominee's details carefully."
	},
	NOMINATE_OWNER: {
		header: "Transfer Ownership",
		body: "This action will initiate the process to transfer the ETR to the nominated party upon approval. Please verify the nominee's details carefully."
	},
	TRANSFER_HOLDER: {
		header: "Transfer Holdership",
		body: "This action will change who has control over the ETR. Ensure the new holder is informed and agrees to this change."
	},
	TRANSFER_OWNERSHIP_HOLDERSHIP: {
		header: "Transfer Ownership & Holdership",
		body: "This action will change who has control over the ETR. Ensure the new owner and holder is informed and agrees to this change."
	},
	ENDORSE_OWNERSHIP: {
		header: "Endorse Transfer",
		body: "This action will finalise the change in beneficiary. Please ensure this aligns with the intended outcome of the nomination."
	},
	SURRENDER: {
		header: "Surrender / Convert to Paper",
		body: "This action will relinquish all rights associated with the ETR. Please confirm your decision."
	}
}

const getIconFillColorType = (isApprovalScreen, eventStatus, status) => {
	const eventStatusMap = {
		PENDING_APPROVAL: "primary",
		FAIL: "danger",
		REJECTED: "danger",
		DEFAULT: "neutral"
	};

	const statusMap = {
		PENDING_APPROVAL: "primary",
		APPROVED: "success",
		REJECTED: "danger",
		DEFAULT: "primary",
	};

	if (!isApprovalScreen) {
		const eStatus = (typeof eventStatus === 'string' ? eventStatus.toUpperCase() : "DEFAULT");
		const matchedStatus = Object.keys(eventStatusMap).find(key => eStatus.includes(key)) || "DEFAULT";
		return eventStatusMap[matchedStatus];
	} else {
		const s = (typeof status === 'string' ? status.toUpperCase() : "DEFAULT");
		return statusMap[s];
	}
}

export { etrActions, etrActionable, MAKER_CHECKER_ETR_MODAL_CONTENT, MAKER_CHECKER_ETR_MODAL_CONTENT_V5, getIconFillColorType };
